import { Fragment } from 'react';
import PropTypes from 'prop-types';

import TopicTopline from 'core/components/TopicTopline';
import TopicFooter from 'core/components/TopicFooter';
import TopicContent from 'core/components/TopicContent';
import TopicHeaderTexts from 'core/components/TopicHeaderTexts';
import SmartArrow from 'core/components/Icon/SmartArrow';
import ArrowRegularSharp from 'core/components/Icon/ArrowRegularSharp';

import Topic from 'core/components/Topic';

import styles from './index.styl';


function SingleTopic(props) {
  const {
    topics,
    pickedTopicIndex,
    backToList,
  } = props;

  if (pickedTopicIndex === null) return null;

  const topic = topics[pickedTopicIndex];

  return (
    <Fragment>
      <Topic content={topic} disableMeta>
        {content => (
          <Fragment>
            <TopicTopline />
            <div className={styles.topicTitle}>
              <TopicHeaderTexts topic={{ content }} />
            </div>
            <TopicContent />
            <TopicFooter content={content} />
          </Fragment>
        )}
      </Topic>
      <button onClick={backToList} className={styles.scrollButton}>
        <SmartArrow direction='left' icon={ArrowRegularSharp} />
        <span className={styles.scrollButtonText}>Вернуться к&#160;списку</span>
      </button>
    </Fragment>
  );
}

SingleTopic.propTypes = {
  /**
   * Офлайн-топики предзагруженные в localStorage
   */
  topics: PropTypes.array,
  /**
   * Индекс просматриваемого топика из localStorage
   */
  pickedTopicIndex: PropTypes.number,
  /**
   * Обработчик позволяющий вернуться обратно к списковой странице топиков
   */
  backToList: PropTypes.func.isRequired,
};

export { SingleTopic as StorybookComponent };
export default SingleTopic;
